import { useState } from "react";
import {
  Box,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import {
  CustomAvatar,
  CustomTableFooter,
  StyledTableCell,
  StyledTableRow,
} from "../../../components";
import { MoreVert } from "@mui/icons-material";

const style = {
  fontSize: 14,
  color: theme.colors.black,
  fontWeight: 550,
};

const MenuProps = {
  PaperProps: {
    style: {
      paddingRight: 20,
    },
  },
};

interface Props {
  data: any;
  onBlock?: (item: any) => void;
}

function SinistreTable({ data, onBlock }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ mb: 2, boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)" }}
    >
      {data.length ? (
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ bgcolor: "#fff" }}>
              <TableCell sx={style}>#</TableCell>
              <TableCell sx={style}>
                <Typography>{capitalizeFirstLetter(i18n.t("boss"))}</Typography>
              </TableCell>
              <TableCell sx={style}>
                <Typography>
                  {capitalizeFirstLetter(i18n.t("grouilleur"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}>
                <Typography ml={1}>
                  {capitalizeFirstLetter(i18n.t("message"))}
                </Typography>
              </TableCell>
              <TableCell sx={style}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : data
            ).map((item: any, index: any) => (
              <StyledTableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  cursor: "pointer",
                }}
              >
                <StyledTableCell>{item.id}</StyledTableCell>
                <StyledTableCell>
                  <Stack direction={"row"} alignItems="center">
                    <CustomAvatar
                      rootStyle={{
                        border: "none",
                        marginTop: 0,
                        marginLeft: 0,
                        marginRight: 1.5,
                      }}
                      avatarStyle={{ borderRadius: 100 }}
                    />
                    <Typography>{`${item.boss?.nom} ${item.boss?.prenom}`}</Typography>
                  </Stack>
                </StyledTableCell>
                <StyledTableCell>{`${item.initiateur?.nom} ${item.initiateur?.prenom}`}</StyledTableCell>
                <StyledTableCell>{item.message}</StyledTableCell>
                <StyledTableCell style={{ width: 40 }}>
                  <Select
                    MenuProps={MenuProps}
                    disableUnderline
                    variant="standard"
                    IconComponent={(props) => (
                      <MoreVert
                        {...props}
                        sx={{ border: "1px solid #EAEAEA", borderRadius: 100 }}
                      />
                    )}
                  >
                    {/* <MenuItem
                      // onClick={() => onEdit(item)}
                      style={{
                        background: "white",
                        color: theme.colors.black,
                      }}
                    >
                      {capitalizeFirstLetter(i18n.t("creer_bara"))}
                    </MenuItem>
                    <MenuItem
                      // onClick={() => onEdit(item)}
                      style={{
                        background: "white",
                        color: theme.colors.red,
                      }}
                    >
                      {capitalizeFirstLetter(i18n.t("supprimer"))}
                    </MenuItem> */}
                  </Select>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          <CustomTableFooter
            rowsPerPage={rowsPerPage}
            data={data}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Table>
      ) : (
       <Box p={15}>
         <Typography textAlign={"center"}>{i18n.t("no_data")}</Typography>
       </Box>
      )}
    </TableContainer>
  );
}

export default SinistreTable;
